<template>
  <div class="stran-brez-izbirnika pregled-vsebine">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          Piškotki
        </p>
<!--        <p>-->
<!--          <img src="https://www.t-2.net/sites/www.t2.si/files/styles/hero/public/Chocolate_Chip_Cookies_-_kimberlykv.jpg?itok=nQS6Z82d" width="100%"/>-->
<!--        </p>-->
        <p style="padding-top: 20px;">Naša spletna stran za namen izboljšave delovanja uporablja piškotke.</p>
        <p>Piškotki so majhne datoteke, ki se naložijo na vaš računalnik z namenom izboljšanja uporabniške izkušnje.</p>
        <p>Spodnje tabele prikazujejo piškotke, ki jih uporabljamo na spletni strani:</p>
        <div v-for="(cookie, index) in cookies.list" :key="`cookieItem-${index}`" style="padding-top: 50px;">
          <div class="open-sans-20pt">{{cookie.label}}</div>
          <div style="padding: 10px 0px;">{{cookie.description}}</div>
          <el-table
            :data="cookie.items"
            style="width: 100%">
            <el-table-column
                    width="150"
            >
                <template slot="header" slot-scope="scope">
                    <div>Ime piškotka / </div>
                    <div>podjetje</div>
                </template>
                <template slot-scope="scope">
                    <div>{{scope.row.name}}</div>
                    <div style="font-style: italic;">{{scope.row.domain}}</div>
                </template>
            </el-table-column>
            <el-table-column
              prop="expiresIn"
              label="Trajanje"
              width="90"
            >
            </el-table-column>
            <el-table-column
              prop="description"
              label="Opis"
              style="width: 50%;"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="cookieBox">
          <div class="open-sans-20pt" style="padding: 50px 0 10px 0;">Nastavitve za nameščanje piškotkov:</div>
          <div class="open-sans-14pt">Z vklopom piškotkov skupin lahko nadzirate, katere piškotke bo spletna stran
            namestila na vašo napravo. Svojo odločitev boste lahko vedno spremenili.</div>
          <div class="cookieDetails" style="padding-top: 10px;">
            <div v-for="(cookie, index) in cookies.list" :key="`cookieItem-${index}`">
              <el-checkbox class="checkbox20" v-model="cookie.value" :disabled="cookie.required">{{cookie.label}}</el-checkbox>
            </div>
            <div style="padding-top: 10px;">
              <el-button id="cookieBtnShraniIzbrano" class="cookieBtnShraniInZapri" @click="cookies.shraniPiskotke()">SHRANI NASTAVITVE</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CookiesLogic from '../../../assets/js/CookiesLogic'
import {Table, TableColumn, Checkbox, Button} from 'element-ui'

export default {
  name: 'CookiesPage',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data () {
    return {
      cookies: CookiesLogic.getInstance()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/CookiesPage.vue